import React from "react";
import PropTypes from "prop-types";

class ProgressBar extends React.Component {
  static propTypes = {
    percent: PropTypes.number,
    width: PropTypes.any,
    className: PropTypes.string,
    backgroundColor: PropTypes.string,
    progressColor: PropTypes.string,
  };

  static defaultProps = {
    percent: 0,
    width: "200px",
    backgroundColor: "#f3f3f3", //colors.gray110,
    progressColor: "#00a0cc", //colors.blue300,
  };

  render() {
    let percentWidth = this.props.percent + "%";
    if (this.props.percent <= 1) {
      percentWidth = this.props.percent * 100 + "%";
    }

    return (
      <div className={`et--progress-bar ${this.props.className || ""}`} style={{ width: this.props.width }}>
        <div className="et--progress-bar--outer" style={{ backgroundColor: this.props.backgroundColor }}>
          <div
            className="et--progress-bar--inner"
            style={{ width: percentWidth, backgroundColor: this.props.progressColor }}
          />
        </div>
      </div>
    );
  }
}

export default ProgressBar;
